import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import getActorById from "../../api/getActorById";
import getMediaById from "../../api/getMediaById";
import WebShare from "./web";
import MobileShare from "./mobile";
import Loader from "../Loader";
import WebHeader from "../Header/web";
import MobileHeader from "../Header/mobile";
import Footer from "../Footer";
import HelpModal from "../Modal/Help";
import { Helmet } from "react-helmet-async";
import PageLayout from "../PageLayout";

export default function Share({ isMobile }) {

    const [blocks, setBlocks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showHelp, setShowHelp] = useState(false);
    const [searchParams] = useSearchParams();
    const puzzleDate = searchParams.get("dt");

    useEffect(() => {
        const fetchBlocksNew = async () => {
            const blocksParam = searchParams.get("blocks");
            if (!blocksParam) {
                setLoading(false);
                return;
            }
        
            const blockIds = blocksParam.split(",");
        
            try {
                const fullBlocks = await Promise.all(
                    blockIds.map(async (blockId, idx) => {
                        let id = blockId; // Ensure mutability
                        let ribbon = false;
                        let strike = false;
                        let hint = false;
                        // Remove "-r" or "-s" suffix
                        if (id.endsWith("-r")) {
                            ribbon = true;
                            id = id.substring(0, id.length - 2);
                        } else if (id.endsWith("-s")) {
                            strike = true;
                            id = id.substring(0, id.length - 2);
                        } 
                        else if (id.endsWith("-h")) {
                            hint = true;
                            id = id.substring(0, id.length - 2);
                        }          
                        // Remove first character
                        if (id.startsWith("M")) {
                            id = id.replace(/^M/, ""); // Remove "M"
                            const mediaBlock = await getMediaById(id);
                            return { ...mediaBlock, type: "MEDIA", select_count: ribbon ? 0 : mediaBlock.select_count, strike, hint };
                        } else {
                            id = id.substring(1); // Remove "A"
                            const actorBlock = await getActorById(id);
                            return { ...actorBlock, type: "ACTOR", select_count: ribbon ? 0 : actorBlock.select_count, strike, hint };
                        }
                    })
                );
        
                setBlocks(fullBlocks);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBlocksNew();
    }, []);

    const chooseContent = () => {
        if(loading){
            return <Loader show={loading} />
        }
        else{
            return isMobile ? <MobileShare puzzleDate={puzzleDate} blocks={blocks} isMobile={isMobile}/> : <WebShare blocks={blocks} puzzleDate={puzzleDate} isMobile={isMobile}/>
        }
    }

       useEffect(() => {
            document.title = "CineSnake - Results";
        }, [])

    return(
        <PageLayout isMobile={isMobile} setShowHelp={setShowHelp}>
            <Helmet>
                <title>{"CineSnake - Results"}</title>
                <meta property="og:title" content={"CineSnake - Results"} />
                <meta property="og:description" content="Check out these CineSnake results!" />
                {/* <meta property="og:image" content={"/public/android-chrome-512x512.png"} /> */}
                <meta property="og:url" content={window.location.href} />
            </Helmet>
            {isMobile ? <MobileHeader strikes={0} setShowHelp={setShowHelp} />:<WebHeader strikes={0} setShowHelp={setShowHelp} />}
            {chooseContent()}
            {showHelp && <HelpModal show={showHelp} onClose={() => setShowHelp(false)} />}
        </PageLayout>
    )
}